export const getSingleQuiz = (payload?: any) => ({
    type: "@saga/GET_SINGLE_QUIZ",
    payload
});

